/**
 * Created by vladislav on 19.05.2020
 */

const WordsListComponent = cc.Node.extend({
    ctor: function (options) {
        this._super();

        this.options = options;

        this.setAnchorPoint(0.5, 0.5);

        const styles = cleverapps.styles.WordsListComponent;
        const wordWidth = this.options.width - 2 * styles.word.padding.x;
        const wordHeight = styles.word.height;
        const baseWords = this.options.words;
        const minimalWordsAmount = this.options.minimalWordsAmount;

        if (baseWords.length < minimalWordsAmount) {
            const len = minimalWordsAmount - baseWords.length;
            for (let index = 0; index < len; index++) {
                baseWords.push("");
            }
        }

        const words = baseWords.map((word) => this.createWord(word, wordWidth, wordHeight));

        const wordsLayout = new cleverapps.GridLayout(words, {
            columns: 2,
            direction: cleverapps.UI.VERTICAL,
            reversed: true,
            margin: styles.words.margin,
            padding: styles.words.padding
        });

        const scroll = this.createScroll(wordsLayout);

        const container = new cc.Node();
        container.setAnchorPoint(0.5, 0.5);
        container.setContentSize2(scroll.width, this.options.height);
        container.addChild(scroll);

        this.setContentSize2(container.width, container.height + 2 * styles.topPadding);
        this.addChild(container);
        scroll.setAlignment(this.width / 2, this.height / 2);
        container.setAlignment(this.width / 2, this.height / 2);

        const bg = new cc.Scale9Sprite(bundles.wordlist.frames.words_border_png);
        bg.setContentSize(wordWidth * 2, Math.min(this.options.height, wordsLayout.height));
        bg.setAlignment(this.width / 2, this.height / 2);
        container.addChild(bg);
    },

    createWord: function (word, wordWidth, wordHeight) {
        const styles = cleverapps.styles.WordsListComponent;
        const wordNode = new cc.Node();

        wordNode.setAnchorPoint(0.5, 0.5);
        wordNode.setContentSize2(wordWidth, wordHeight);

        const bg = this.createWordBg(wordWidth, wordHeight);
        wordNode.addChild(bg);
        bg.setAlignment(wordNode.width / 2, wordNode.height / 2);

        const text = cleverapps.UI.generateOnlyText(word.toUpperCase(), cleverapps.styles.FONTS.WHITE_TEXT);
        wordNode.addChild(text);
        text.setAlignment(styles.word.text);

        return wordNode;
    },

    createScroll: function (content) {
        const styles = cleverapps.styles.WordsListComponent;
        const scroll = new cleverapps.UI.ScrollView(content, {
            outOfBoundaryScale: false
        });
        scroll.setBarPadding(styles.scroll.barPadding);
        scroll.setContentSize2(this.options.width * 2 + styles.scroll.barPadding.sidePadding, styles.scroll.height);
        scroll.scrollToPercent(100);
        return scroll;
    },

    createWordBg: function (width, height) {
        const padding = cleverapps.styles.WordsListComponent.word.bg.padding;

        const bg = new cc.Scale9Sprite(bundles.wordlist.frames.words_bg_png);
        bg.setContentSize2(width - padding, height - padding);

        return bg;
    }
});

cleverapps.styles.WordsListComponent = {
    word: {
        height: 70,
        padding: {
            x: 25
        },
        text: {
            x: { align: "center" },
            y: { align: "center", dy: -5 }
        },
        bg: {
            padding: 3
        }
    },
    scroll: {
        height: 300,
        padding: {
            x: 30
        },
        barPadding: {
            sidePadding: 20
        }
    },
    words: {
        margin: 200,
        padding: {
            x: 0,
            y: 5
        }
    },
    topPadding: 4
};